<template>
  <div class="page-footer" id="footer">
    <section class="footer-color-bar">
      <b-container class="footer-info" fluid="xl">
        <b-row>
          <b-col cols="4" xl="2" md="2" sm="4" class="info-item info-bar">
            <b-row
              ><header>{{ $t('footer-title') }}</header></b-row
            >
            <b-row class="dots">
              <span class="dot"></span>
              <span class="dot"></span>
              <span class="dot"></span>
            </b-row>
          </b-col>
          <b-col cols="8" xl="8" md="8" sm="8" class="info-item">
            <p class="mb-4">{{ $t('contact-email') }}</p>
            <p class="mb-4">{{ $t('contact-tel') }}</p>
            <p class="mb-4">{{ $t('contact-address') }}</p>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="copyright">
            <p>{{ $t('footer-copyright') }}</p>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PageFooter'
}
</script>

<style scoped lang="scss">
.page-footer {
  padding-bottom: 0;
  .footer-color-bar {
    height: max-content;
    background: linear-gradient(90deg, #5e7bbc, #b37cd0);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 20px;

    h3 {
      font-size: 22px;
      font-weight: 700;
      color: #ffffff;
    }

    p {
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
      line-height: 1;
      margin-top: 0.1rem;
    }
  }

  .footer-info {
    padding-top: 1rem;

    .vl {
      color: #ffffff;
    }

    .copyright {
      p {
        font-size: 0.5rem;
        text-align: center;
      }
    }

    .info-item {
      header {
        font-size: 2rem;
        font-weight: 700;
        color: #ffffff;
        margin-bottom: 1rem;
      }

      .dots {
        width: 7rem;
        justify-content: space-between;
        text-align: center;
      }

      .dot {
        display: inline-block;
        border-radius: 50%;
        background-color: #ffffff;
        height: 1rem;
        width: 1rem;
      }

      p {
        font-size: 15px;
        font-weight: 500;
        color: #ffffff;
      }

      .blod-info {
        display: flex;
        align-items: center;
        font-size: 15px;
        font-weight: 700;
        color: #ffffff;

        img {
          width: 18px;
          margin-right: 10px;
        }
      }
    }

    .info-bar {
      border-right-style: solid;
      border-color: #ffffff;
    }
  }
}
</style>

<style scoped lang="scss">
@media (max-width: 768px) {
  .footer-color-bar {
    text-align: left;
    h3 {
      font-size: 16px !important;
    }
    p {
      font-size: 12px !important;
      padding-left: 1.5rem;
    }
  }

  .footer-info {
    .info-item {
      header {
        font-size: 1.5rem !important;
      }

      .dots {
        width: 5.5rem !important;
      }

      .dot {
        height: 0.7rem !important;
        width: 0.7rem !important;
      }

      p {
        margin-bottom: 1rem !important;
      }
    }

    .info-bar {
      height: 7rem;
    }
  }
}
</style>
